import { render, staticRenderFns } from "./Orientation.vue?vue&type=template&id=e48e4d90&scoped=true"
import script from "./Orientation.vue?vue&type=script&lang=js"
export * from "./Orientation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48e4d90",
  null
  
)

export default component.exports